import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

export default function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqs = [
    {
      question: "What is your return policy?",
      answer: "We offer a 30-day return policy for all items in original condition with tags attached. Items must be unworn and unwashed. Returns are free within the US, and we'll provide a prepaid return label. Custom Made/Personalized Dresses are not refundable."
    },
    {
      question: "How long does shipping take?",
      answer: "Shipping times vary by product type: Jewelry and Shoes are available only in the USA with 3-5 day delivery. Custom Made Dresses have international shipping with 7-14 days processing time and 5-14 days delivery time. For urgent orders, please contact us for quick shipping options."
    },
    {
      question: "Do you offer international shipping?",
      answer: "Yes! Custom Made Dresses are available for international shipping with 7-14 days processing and 5-14 days delivery. Jewelry and Shoes are currently only available in the USA. We offer FREE shipping on orders over $50."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, MasterCard, American Express), PayPal, Apple Pay, Google Pay, and Shop Pay. All payments are processed securely through our encrypted checkout system."
    },
    {
      question: "How do I find my size?",
      answer: "We provide detailed size charts for all our products. Please refer to our Size Guide page for measurements and sizing information. If you're still unsure, our customer service team can help you find the perfect fit."
    },
    {
      question: "Can I track my order?",
      answer: "Yes! Once your order ships, you'll receive a tracking number via email. You can track your package directly from your order confirmation email or by logging into your account."
    },
    {
      question: "Do you have a physical store?",
      answer: "Currently, we operate as an online-only store. However, we're always looking to expand! Follow us on social media for updates about potential physical locations."
    },
    {
      question: "How do I care for my dress?",
      answer: "Most of our dresses should be hand washed in cold water and air dried. Please check the care label on each item for specific instructions. Avoid using bleach or fabric softener."
    },
    {
      question: "What if my item is damaged or defective?",
      answer: "We're sorry to hear that! Please contact our customer service team immediately with photos of the damage. We'll arrange for a replacement or full refund at no cost to you."
    },
    {
      question: "Do you offer gift wrapping?",
      answer: "Yes! We offer beautiful gift wrapping for an additional fee. You can select this option during checkout, and we'll include a gift message if desired."
    },
    {
      question: "Do you offer free shipping?",
      answer: "Yes! We offer FREE shipping on all orders over $50. This applies to both domestic and international orders. For orders under $50, standard shipping rates apply."
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
            Frequently Asked Questions
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Find answers to common questions about our products, shipping, returns, and more.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-900 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-800 transition-colors"
              >
                <h3 className="text-lg font-semibold text-white pr-4">{faq.question}</h3>
                {openItems[index] ? (
                  <FiChevronUp className="text-pink-500 flex-shrink-0" size={24} />
                ) : (
                  <FiChevronDown className="text-pink-500 flex-shrink-0" size={24} />
                )}
              </button>
              {openItems[index] && (
                <div className="px-6 pb-6">
                  <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Still Have Questions?</h2>
            <p className="text-gray-400 mb-6">
              Can't find what you're looking for? Our customer service team is here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 bg-pink-500 text-white font-semibold rounded-lg hover:bg-pink-600 transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
